const cartDrawerGiftWrapping = () => {
    const classes = {
        giftWrappingActive: 'drawer__gift-wrapping--active',
        giftWrappingAccordionTitleDisabled: 'gift-wrapping__title--disabled',
    };
    const selectors = {
        giftWrappingVariant: 'data-cart-drawer-gift-wrapping-variant',
        giftWrappingAccordion: '[data-cart-drawer-gift-wrapping-accordion]',
        giftWrappingAccordionTitle: '[data-cart-drawer-gift-wrapping-accordion-title]',
        giftWrappingAccordionContent: '[data-cart-drawer-gift-wrapping-accordion-content]',
        giftWrappingMessage: '[data-cart-drawer-gift-wrapping-message]',
        giftWrappingMessageCharacterCount: '[data-cart-drawer-gift-wrapping-message-character-count]',
        giftWrappingMessageStatus: '[data-cart-drawer-gift-wrapping-message-status]',
        checkoutButton: 'CartDrawer-Checkout',
        openOnLoad: 'open-on-load',
    };
    const updateCartGiftWrapping = () => {
        const giftWrappingAccordion = document.querySelector(selectors.giftWrappingAccordion);
        if (giftWrappingAccordion) {
            const giftWrappingVariant = giftWrappingAccordion.getAttribute(selectors.giftWrappingVariant);
            const giftWrappingAccordionTitle = giftWrappingAccordion.querySelector(selectors.giftWrappingAccordionTitle);
            const giftWrappingAccordionContent = giftWrappingAccordion.querySelector(selectors.giftWrappingAccordionContent);
            const giftWrappingMessage = giftWrappingAccordion.querySelector(selectors.giftWrappingMessage);
            const giftWrappingMessageCharacterCount = giftWrappingAccordion.querySelector(selectors.giftWrappingMessageCharacterCount);
            const addGiftWrappingToCart = () => {
                const giftData = {
                    id: giftWrappingVariant,
                    quantity: 1,
                };
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(giftData),
                })
                    .then((response) => {
                    return response.json();
                })
                    .then((json) => {
                    window.dispatchEvent(new CustomEvent('frank-green:gift-wrapping-update', {}));
                })
                    .catch((err) => {
                    console.error(err);
                });
            };
            const updateGiftWrappingInCart = (message) => {
                const noteData = {
                    note: message,
                };
                const giftData = {
                    id: giftWrappingVariant,
                    quantity: 1,
                    properties: {
                        Message: message,
                    },
                };
                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(giftData),
                })
                    .then((response) => {
                    return response.json();
                })
                    .then((json) => {
                    return fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(noteData),
                    })
                        .then((response) => {
                        return response.json();
                    })
                        .catch((err) => {
                        console.error(err);
                    });
                })
                    .then(() => {
                    window.dispatchEvent(new CustomEvent('frank-green:gift-wrapping-update', {}));
                })
                    .catch((err) => {
                    console.error(err);
                });
            };
            const removeGiftWrappingFromCart = () => {
                const noteData = {
                    note: '',
                };
                const giftData = {
                    id: giftWrappingVariant,
                    quantity: 0,
                };
                fetch('/cart/change.js', {
                    body: JSON.stringify(giftData),
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'xmlhttprequest',
                    },
                    method: 'POST',
                })
                    .then((response) => {
                    return response.json();
                })
                    .then((json) => {
                    return fetch('/cart/update.js', {
                        body: JSON.stringify(noteData),
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Requested-With': 'xmlhttprequest',
                        },
                        method: 'POST',
                    })
                        .then((response) => {
                        return response.json();
                    })
                        .catch((err) => {
                        console.error(err);
                    });
                })
                    .then(() => {
                    window.dispatchEvent(new CustomEvent('frank-green:gift-wrapping-update', {}));
                })
                    .catch((err) => {
                    console.error(err);
                });
            };
            const showUpdatingCartMessage = () => {
                const status = giftWrappingAccordion.querySelector(selectors.giftWrappingMessageStatus);
                const chechoutButton = document.getElementById(selectors.checkoutButton);
                giftWrappingAccordionTitle.classList.add(classes.giftWrappingAccordionTitleDisabled);
                if (status) {
                    status.innerHTML = 'Updating Message...';
                }
                if (chechoutButton) {
                    chechoutButton.setAttribute('disabled', 'disabled');
                }
            };
            if (giftWrappingAccordionTitle) {
                giftWrappingAccordionTitle.addEventListener('click', () => {
                    giftWrappingAccordion.classList.toggle(classes.giftWrappingActive);
                    giftWrappingAccordionTitle.classList.add(classes.giftWrappingAccordionTitleDisabled);
                    if (giftWrappingAccordionContent) {
                        giftWrappingAccordionContent.remove();
                        if (giftWrappingVariant) {
                            removeGiftWrappingFromCart();
                        }
                    }
                    else {
                        if (giftWrappingVariant) {
                            addGiftWrappingToCart();
                        }
                    }
                });
            }
            if (giftWrappingMessage && giftWrappingMessageCharacterCount) {
                const updateCharacterCounter = () => {
                    const characterLength = giftWrappingMessage.value.length;
                    giftWrappingMessageCharacterCount.innerHTML = characterLength + '/250';
                };
                updateCharacterCounter();
                giftWrappingMessage.addEventListener('keyup', () => {
                    const chechoutButton = document.getElementById(selectors.checkoutButton);
                    if (chechoutButton) {
                        chechoutButton.setAttribute('disabled', 'disabled');
                    }
                    updateCharacterCounter();
                });
                let typingTimer;
                const doneTypingInterval = 750;
                giftWrappingMessage.addEventListener('keyup', () => {
                    clearTimeout(typingTimer);
                    typingTimer = setTimeout(doneTyping, doneTypingInterval);
                });
                const doneTyping = () => {
                    showUpdatingCartMessage();
                    updateGiftWrappingInCart(giftWrappingMessage.value);
                };
            }
        }
    };
    updateCartGiftWrapping();
    window.addEventListener('frank-green:cart-reloaded', () => {
        updateCartGiftWrapping();
    });
};
export { cartDrawerGiftWrapping };
